/* This file is auto-generated from Amplify hook (post-push.sh). Do not modify! */
export default {
    "AWS_FILE_GENERATOR_LAMBDA": "slackbot-servicenow-pdf-prod-file-generator-lambda",
    "AWS_PDF_STORAGE_BUCKET": "slackbot-servicenow-pdf-prod-pdf-storage-bucket"
};
